export default "__VITE_ASSET__COfFGvv0__"